import { Link } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import { Gift } from "lucide-react";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const Logo = ({ className = "", size = "md" }: LogoProps) => {
  const { user } = useAuth();

  const sizeClasses = {
    sm: "h-4 w-4 sm:h-5 sm:w-5",
    md: "h-5 w-5 sm:h-6 sm:w-6",
    lg: "h-6 w-6 sm:h-7 sm:w-7"
  };

  const textSizeClasses = {
    sm: "text-sm sm:text-base",
    md: "text-base sm:text-lg",
    lg: "text-lg sm:text-xl"
  };

  return (
    <Link
      to={user ? "/" : "/login"}
      className={`hover:opacity-80 transition-opacity ${className}`}
    >
      <div className="flex items-center gap-1.5 sm:gap-2">
        <Gift className={`${sizeClasses[size]} text-primary`} />
        <span className={`font-bold ${textSizeClasses[size]} text-foreground`}>BuyForS</span>
      </div>
    </Link>
  );
};
